/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {OBJECT_TYPE} from '../../common/constants/object-type';

export function getLastViewedProfileKey(networkId: string, app: string): string {
  return 'adnLastViewed' + networkId + (app === 'ADVERTISING' ? '' : app);
}

export function buildLastViewedEntries(localUserProfile: any, LocalNetworkProfile: any, enrichObjType = true): any[] {
  const app = localUserProfile.getCurrentApp();
  const profileKey = getLastViewedProfileKey(LocalNetworkProfile.getNetworkId(), app);
  const entries = _.get(localUserProfile.get(), ['profile', profileKey]) || [];

  if (!enrichObjType) {
    return entries;
  }

  return _.map(entries, function(entry) {
    const enriched = {...entry};
    const objType = OBJECT_TYPE[entry.objectType];
    if (objType) {
      enriched.objType = objType;
    }
    return enriched;
  });
}
